import { z } from 'zod';
export const workItemActivityEntrySchema = z.object({
    id: z.string().uuid(),
    occurred_at: z.string().datetime(),
    event_kind: z.string(),
    summary: z.string(),
    attribution: z.string().nullable().optional(),
    trace_kind: z.string().min(1).max(64).nullable().optional(),
});
export const workItemActivityListResponseSchema = z.object({
    entries: z.array(workItemActivityEntrySchema),
    next_cursor: z.string().nullable(),
});
export const workItemActivityListQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z
        .preprocess((v) => (v === undefined || v === null || v === '' ? undefined : v), z.coerce.number().int().optional())
        .transform((n) => {
        const base = n ?? 20;
        return Math.min(100, Math.max(1, base));
    }),
});
export function parseWorkItemActivityListQuery(input) {
    return workItemActivityListQuerySchema.parse(input);
}
function toBase64Url(bytes) {
    if (typeof Buffer !== 'undefined') {
        return Buffer.from(bytes).toString('base64url');
    }
    let bin = '';
    for (let j = 0; j < bytes.length; j++) {
        bin += String.fromCharCode(bytes[j]);
    }
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function fromBase64Url(s) {
    const pad = s.length % 4 === 0 ? '' : '='.repeat(4 - (s.length % 4));
    const b64 = s.replace(/-/g, '+').replace(/_/g, '/') + pad;
    if (typeof Buffer !== 'undefined') {
        return new Uint8Array(Buffer.from(b64, 'base64'));
    }
    const bin = atob(b64);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++)
        out[i] = bin.charCodeAt(i);
    return out;
}
export function encodeActivityTimelineCursor(occurredAt, activityEventId) {
    const payload = {
        u: occurredAt.getTime(),
        i: activityEventId,
    };
    const json = JSON.stringify(payload);
    return toBase64Url(new TextEncoder().encode(json));
}
export function decodeActivityTimelineCursor(cursor) {
    try {
        const bytes = fromBase64Url(cursor);
        const text = new TextDecoder().decode(bytes);
        const parsed = JSON.parse(text);
        const obj = z.object({ u: z.number(), i: z.string().uuid() }).safeParse(parsed);
        return obj.success ? obj.data : null;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=work-item-activity.js.map